import React from "react";
import MainTable from "../../../components/request-table/request-table"

////////////////////////////////////////////////TABLE COLUMN HEADERS SET UP////////////////////////////////////////////////////////////////////////////////////////
const TableData = ({ resetMenu }: any) => {
  return (<MainTable key={"RequestMainTable"} pageTitle="KYC Request All" pageName="all"  resetMenu={resetMenu}/>)
}
export default TableData;
